<template>
  <div
    class="form-message relative bg-white rounded-md mr-3"
    :id="channelIdUser"
  >
    <!-- -->
    <!-- Header -->

    <div class="p-2 w-full justify-between flex items-center head-mes">
      <div>
        <div class="flex w-full items-center cursor-pointer">
          <div class="relative">
            <div
              @click="onClickShowDetailFriend(idUser)"
              v-if="idUser.length === 2"
              :style="`background-image: url('${avatarImage}');`"
              class="rounded-full size-image-small"
            />
            <div
              v-else
              :style="`background-image: url('${imageDefault}');`"
              class="rounded-full size-image-small"
            />
            <img
              v-if="fullNameValue?.onlineNow"
              src="../../assets/icon_svg/ic_active.svg"
              width="10"
              class="img_active"
            />
          </div>
          <div class="pl-3 text-left">
            <div class="text-sm font-semibold" v-if="idUser.length === 2">
              {{ fullNameValue?.fullname }}
            </div>
            <div class="text-sm font-semibold" v-else>Does not exist</div>
            <div class="text-xs" v-if="fullNameValue?.onlineNow">Active</div>
          </div>
          <div>
            <img src="../../assets/icon_svg/ic_down.svg" width="20" alt="" />
          </div>
        </div>
      </div>
      <div class="flex items-center gap-2">
        <div>
          <img
            class="cursor-pointer"
            src="../../assets/icon_svg/ic_thunho.svg"
            width="20"
            alt=""
          />
        </div>
        <img
          @click="onClickHideMessage(channelIdUser)"
          src="../../assets/icon_svg/ic_cancel.svg"
          width="15"
          class="cursor-pointer"
          alt=""
        />
      </div>
    </div>
    <!-- Body -->

    <div class="w-full h-body-mes relative">
      <div class="form-mes text-left p-2" ref="messageContainer">
        <div
          v-if="lengthDataMessage === 0"
          class="flex justify-center items-center mt-5"
        >
          <div class="text-center">
            <div class="relative flex justify-center">
              <div
                :style="`background-image: url('${avatarImage}');`"
                class="rounded-full size-image-big"
              />
            </div>
            <div class="text-sm font-semibold text-center p-2">
              {{ fullNameValue.fullname }}
            </div>
            <div class="text-sm">Các bạn là bạn bè trên Heartconnect</div>
            <div class="text-sm">Sống tại Hà Nội</div>
          </div>
        </div>

        <div
          class="flex justify-end flex-col overflow-x-hidden overflow-y-hidden"
          v-else
        >
          <div
            v-for="(element, indexItem) in groupMessagesByHour(
              propertyData,
              idUserAdmin
            )"
            :key="indexItem"
          >
            <div v-for="(item, index) in element" :key="index">
              <!-- Thời gian tin nhắn -->
              <div class="text-center" v-if="index === 0">
                <div class="text-xs">
                  {{ formatTimestamp(item.insert.when) }}
                </div>
              </div>

              <!-- Nội dung -->
              <div>
                <!-- Single Message -->
                <div
                  v-if="
                    (index === 0 && !element[index + 1]) ||
                    (index === 0 &&
                      element[index + 1] &&
                      element[index + 1].side !== item.side) ||
                    (index > 0 &&
                      element[index + 1] &&
                      element[index - 1] &&
                      element[index + 1].side !== item.side &&
                      element[index - 1].side !== item.side) ||
                    (index > 0 &&
                      element[index + 1] === undefined &&
                      element[index - 1] &&
                      element[index - 1].side !== item.side)
                  "
                  :class="{
                    'w-full justify-start flex mb-1': item.side === 'left',
                    'w-full justify-end flex mb-1': item.side === 'right',
                  }"
                >
                  <div
                    :class="{
                      'text-black text-xl gap-1 grid': item.side === 'left',
                      'text-white text-xl gap-1 grid': item.side === 'right',
                    }"
                  >
                    <div v-if="isIconString(item.message.text)">
                      <div v-html="formattedString(item.message.text)"></div>
                    </div>
                    <div v-else class="text-sm">
                      <div
                        :class="[
                          'pad-mes',
                          item.side === 'left'
                            ? 'bg-slate-200 bor-middle-single'
                            : 'bg-blue-500 bor-middle-single',
                        ]"
                        v-html="formattedString(item.message.text)"
                      ></div>
                    </div>
                  </div>
                </div>
                <!-- First Message -->
                <div
                  v-else-if="
                    (index === 0 &&
                      element[index + 1] &&
                      element[index + 1].side === item.side) ||
                    (index > 0 &&
                      element[index - 1] &&
                      element[index + 1] &&
                      element[index - 1].side !== item.side &&
                      element[index + 1].side === item.side)
                  "
                  :class="{
                    'w-full justify-start flex mb-1': item.side === 'left',
                    'w-full justify-end flex mb-1': item.side === 'right',
                  }"
                >
                  <div
                    :class="{
                      'text-black text-xl gap-1 grid': item.side === 'left',
                      'text-white text-xl gap-1 grid': item.side === 'right',
                    }"
                  >
                    <div v-if="isIconString(item.message.text)">
                      <div v-html="formattedString(item.message.text)"></div>
                    </div>
                    <div v-else class="text-sm">
                      <div
                        :class="[
                          'pad-mes',
                          item.side === 'left'
                            ? 'bg-slate-200 bor-first-left'
                            : 'bg-blue-500 bor-first-right',
                        ]"
                        v-html="formattedString(item.message.text)"
                      ></div>
                    </div>
                  </div>
                </div>
                <!-- Last Message -->
                <div
                  v-else-if="
                    (index > 0 &&
                      element[index + 1] &&
                      element[index + 1].side !== item.side &&
                      element[index - 1].side === item.side) ||
                    (index > 0 &&
                      element[index - 1].side === item.side &&
                      !element[index + 1])
                  "
                  :class="{
                    'w-full justify-start flex mb-1': item.side === 'left',
                    'w-full justify-end flex mb-1': item.side === 'right',
                  }"
                >
                  <div
                    :class="{
                      'text-black text-xl gap-1 grid': item.side === 'left',
                      'text-white text-xl gap-1 grid': item.side === 'right',
                    }"
                  >
                    <div v-if="isIconString(item.message.text)">
                      <div v-html="formattedString(item.message.text)"></div>
                    </div>
                    <div v-else class="text-sm">
                      <div
                        :class="[
                          'pad-mes',
                          item.side === 'left'
                            ? 'bg-slate-200 bor-last-left'
                            : 'bg-blue-500 bor-last-right',
                        ]"
                        v-html="formattedString(item.message.text)"
                      ></div>
                    </div>
                  </div>
                </div>
                <!-- Middle Messages -->
                <div
                  v-else
                  :class="{
                    'w-full justify-start flex mb-1': item.side === 'left',
                    'w-full justify-end flex mb-1': item.side === 'right',
                  }"
                >
                  <div
                    :class="{
                      'text-black text-xl gap-1 grid': item.side === 'left',
                      'text-white text-xl gap-1 grid': item.side === 'right',
                    }"
                  >
                    <div v-if="isIconString(item.message.text)">
                      <div v-html="formattedString(item.message.text)"></div>
                    </div>
                    <div v-else class="text-sm">
                      <div
                        :class="[
                          'pad-mes',
                          item.side === 'left'
                            ? 'bg-slate-200 bor-middle-left'
                            : 'bg-blue-500 bor-middle-right',
                        ]"
                        v-html="formattedString(item.message.text)"
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Footer -->
      <div
        class="w-full pl-3 pr-3 gap-2 flex justify-center items-center absolute bottom-2 left-0"
      >
        <div class="absolute bottom-1 left-0 w-[15%] flex justify-center">
          <img
            src="../../assets/icon_svg/heroicons_gif-solid.svg"
            width="25"
            alt=""
          />
        </div>
        <div
          class="textarea-container relative flex justify-center items-center"
        >
          <div class="flex justify-between w-full relative form-mes-w">
            <div class="relative w-[calc(100%-30px)] flex items-center h-full">
              <textarea
                class="textarea"
                placeholder="Aa"
                rows="1"
                :value="valueMessage"
                ref="inputBar"
                @input="handleInput"
                @keydown="handleKeydown"
              ></textarea>
            </div>
            <div class="w-[30px] flex justify-center items-center">
              <div class="cursor-pointer absolute bottom-2">
                <img
                  @click="onClickEmojiPicker"
                  src="../../assets/icon_svg/ic_smile.svg"
                  width="20"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="absolute right-0 bottom-1 w-[15%] flex justify-center">
          <img
            v-if="valueMessage.length !== 0"
            @click="sendMessageAction()"
            src="../../assets/icon_svg/ic_send.svg"
            class="cursor-pointer"
            width="25"
          />
          <img
            v-else
            @click="sendHandIcon('👋')"
            src="../../assets/icon_svg/ic_hands.svg"
            class="cursor-pointer"
            width="25"
          />
        </div>
      </div>
    </div>

    <div
      v-if="isShowEmojis"
      class="absolute w-full h-full bottom-0 right-0 z-form"
      @click="onClickMessageIcon"
    >
      <div class="relative h-full">
        <div class="absolute form-icon" ref="fomMesRef">
          <EmojiPicker :native="true" @select="onSelectEmoji" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from "vue";

import "vue3-emoji-picker/css";
import { socket, state } from "@/configs/webSocketService.js";

import EmojiPicker from "vue3-emoji-picker";
import { ElMessage } from "element-plus";
import { mapMutations, mapActions } from "vuex";

export default {
  name: "form-chat",
  components: { EmojiPicker },
  data() {
    return {
      imageDefault: require("@/assets/icon_svg/image_default.jpg"),
      valueMessage: "",
      textMessage: "Say something nice",
      isShowEmojis: false,
    };
  },

  setup() {
    const errorSend = () => {
      ElMessage.error("Error, Cannot send message");
    };

    const isConnected = ref(false);
    onMounted(() => {
      // Lắng nghe sự kiện khi kết nối thành công
      socket.onopen = () => {
        console.log("Vao");
        isConnected.value = true;
      };
    });
    return {
      errorSend,
    };
  },

  computed: {
    lengthDataMessage() {
      return this.listDetailMessage.dataMessages.length;
    },
    idUserAdmin() {
      return localStorage.getItem("idUser");
    },
    idUser() {
      return this.listDetailMessage.dataClient;
    },
    channelIdUser() {
      return this.listDetailMessage.idChannel;
    },
    fullNameValue() {
      const idUserLocal = localStorage.getItem("idUser");
      const findName = this.listDetailMessage.dataClient.find(
        (x) => x._id !== idUserLocal
      );
      return findName;
    },

    avatarImage() {
      const idUserLocal = localStorage.getItem("idUser");
      const image = this.listDetailMessage.dataClient.find(
        (x) => x._id !== idUserLocal
      );
      return image.profiles.avatars[0].meta.url;
    },

    propertyData() {
      const newMessage = this.listDetailMessage.dataMessages;
      debugger;
      newMessage.sort(
        (a, b) => new Date(a.insert.when) - new Date(b.insert.when)
      );

      // Tạo một danh sách group để n hóm tin nhắn
      // const group = [];
      // let index = 0;
      // // Biến trung gian để theo dõi tin nhắn của từng nhóm
      // let currentGroup = [];
      // for (const message of newMessage) {
      //   // Check xem currentGroup !==0 hay không.
      //   if (currentGroup.length === 0) {
      //     // Push phần tử đầu tiên
      //     currentGroup[index] = [message];
      //   } else {
      //     // Lần sau khi đã tồn tại giá trị trong currentGroup
      //     const findId = currentGroup[index].filter(
      //       (x) => x.senderId === message.senderId
      //     );
      //     if (findId.length === 0) {
      //       currentGroup[index].push(message);
      //     } else {
      //       const timeFind = new Date(findId[length - 1].insert.when);
      //       const timeMessage = new Date(message.insert.when);

      //       const timeDifference = Math.abs(timeMessage - timeFind);
      //       if (timeDifference > 200000) {
      //         group.push(currentGroup[index]);
      //         index = index + 1;
      //         currentGroup[index] = [message];
      //       } else {
      //         currentGroup[index].push(message);
      //       }
      //     }

      //     // Tòn tại A or có B
      //   }
      // }

      this.scrollDownToNewMessage();
      return newMessage;
    },

    idChannelMessage() {
      return this.listDetailMessage.idChannel;
    },
  },

  mounted() {},

  props: {
    listDetailMessage: {
      type: Object,
      required: true,
    },
    receivedData: {
      type: Object,
      required: true,
    },
  },

  methods: {
    ...mapMutations(["setRemoveMessage", "setInformationUserAdmin"]),
    ...mapActions(["addMessageChanel", "getListChanelId"]),
    // Send message text
    async sendMessageAction() {
      if (this.idUser.length === 2) {
        await this.addMessageChanel({
          idMessage: this.idChannelMessage,
          objectMessage: {
            text: this.valueMessage,
            image: "",
            icons: [],
            reacts: [],
          },
        });
        this.valueMessage = "";
        this.$refs.inputBar.focus();
        this.setDefaultTextareaHeight();
        this.getListChanelId({
          pageSize: 50,
          currentPage: 0,
        });
      } else {
        this.valueMessage = "";
        this.errorSend();
      }
    },

    formatTimestamp(timestamp) {
      const daysOfWeek = ["CN", "T2", "T3", "T4", "T5", "T6", "T7"];
      const date = new Date(timestamp);

      const hours = date.getHours().toString().padStart(2, "0");
      const minutes = date.getMinutes().toString().padStart(2, "0");
      const dayOfWeek = daysOfWeek[date.getDay()];

      return `${hours}:${minutes} ${dayOfWeek}`;
    },
    // groupMessagesByHour(messages) {
    //   const groups = [];
    //   let currentGroup = [];

    //   for (let i = 0; i < messages.length; i++) {
    //     const message = messages[i];
    //     const messageTime = new Date(message.insert.when);

    //     if (currentGroup.length === 0) {
    //       currentGroup.push(message);
    //     } else {
    //       const previousMessageTime = new Date(
    //         currentGroup[currentGroup.length - 1].insert.when
    //       );
    //       const timeDifference =
    //         (messageTime - previousMessageTime) / (1000 * 60 * 60); // Chênh lệch thời gian tính bằng giờ

    //       if (timeDifference > 1) {
    //         groups.push(currentGroup);
    //         currentGroup = [message];
    //       } else {
    //         currentGroup.push(message);
    //       }
    //     }
    //   }

    //   if (currentGroup.length > 0) {
    //     groups.push(currentGroup);
    //   }
    //   debugger;
    //   return groups;
    // },

    groupMessagesByHour(messages, userId) {
      const groups = [];
      let currentGroup = [];

      for (let i = 0; i < messages.length; i++) {
        const message = messages[i];
        const messageTime = new Date(message.insert.when);
        const side = message.senderId === userId ? "right" : "left";
        const messageWithSide = { ...message, side };

        if (currentGroup.length === 0) {
          currentGroup.push(messageWithSide);
        } else {
          const previousMessageTime = new Date(
            currentGroup[currentGroup.length - 1].insert.when
          );
          const timeDifference =
            (messageTime - previousMessageTime) / (1000 * 60 * 60); // Chênh lệch thời gian tính bằng giờ

          if (timeDifference > 1) {
            groups.push(currentGroup);
            currentGroup = [messageWithSide];
          } else {
            currentGroup.push(messageWithSide);
          }
        }
      }

      if (currentGroup.length > 0) {
        groups.push(currentGroup);
      }
      debugger;
      return groups;
    },

    // handle input text
    handleInput(event) {
      // Lấy giá trị của trường input
      this.valueMessage = event.target.value;
      console.log("this.valueMessage", this.valueMessage.length);
      event.preventDefault();

      if (this.valueMessage.trim().length !== 0) {
        setTimeout(() => {
          this.adjustTextareaHeight();
        }, 0);
      }
    },

    async handleKeydown(event) {
      if (event.key === "Enter" && event.shiftKey) {
        event.preventDefault();
        const textarea = this.$refs.inputBar;
        const start = textarea.selectionStart;
        const end = textarea.selectionEnd;
        this.valueMessage =
          this.valueMessage.substring(0, start) +
          "\n" +
          this.valueMessage.substring(end);
        this.$nextTick(() => {
          console.log("vào 1");
          textarea.selectionStart = textarea.selectionEnd = start + 1;
          this.adjustTextareaHeight();
          textarea.setSelectionRange(start + 1, start + 1);
        });
      } else {
        if (event.key === "Enter") {
          event.preventDefault();

          if (this.valueMessage.trim().length !== 0) {
            console.log("this.valueMessage", this.valueMessage);
            this.sendMessageAction();
          }
        }
      }
    },

    setDefaultTextareaHeight() {
      const textarea = this.$refs.inputBar;
      const formMesW = this.$el.querySelector(".form-mes-w");
      const formMesChat = this.$el.querySelector(".form-mes");

      // Reset the height to auto to get the correct scrollHeight
      textarea.style.height = "auto";

      // Calculate the new height of the textarea

      // Set the new height of the textarea
      textarea.style.height = `100%`;

      // Update the height of formMesW based on the new textarea height
      formMesW.style.height = `35px`;

      // Update the height of formMesChat based on the new formMesW height
      formMesChat.style.height = `21rem`;
      this.scrollDownToNewMessage();
    },

    adjustTextareaHeight() {
      const textarea = this.$refs.inputBar;

      console.log("textarea", textarea);
      console.log("textarea-value", textarea.value.length);
      const formMesW = this.$el.querySelector(".form-mes-w");
      const formMesChat = this.$el.querySelector(".form-mes");

      // Reset the height to auto to get the correct scrollHeight
      textarea.style.height = "auto";

      // Calculate the new height of the textarea
      const newHeight = textarea.scrollHeight;
      console.log("newHeight", newHeight);

      if (newHeight !== 32) {
        textarea.style.height = `${newHeight}px`;

        // Update the height of formMesW based on the new textarea height
        formMesW.style.height = `${newHeight + 20}px`;

        // Update the height of formMesChat based on the new formMesW height
        formMesChat.style.height = `calc(100% - ${newHeight + 30}px)`;
      } else {
        textarea.style.height = `100%`;

        // Update the height of formMesW based on the new textarea height
        formMesW.style.height = `35px`;

        // Update the height of formMesChat based on the new formMesW height
        formMesChat.style.height = `21rem`;
      }
      this.scrollDownToNewMessage();

      // Set the new height of the textarea
    },

    onClickMessageIcon(event) {
      const fomMesRef = this.$refs.fomMesRef;

      if (fomMesRef && !fomMesRef.contains(event.target)) {
        console.log("Click bên ngoài phần tử");
        this.isShowEmojis = false;
      } else {
        console.log("Click bên trong phần tử");
      }
    },

    onSelectEmoji(emoji) {
      // Xử lý khi chọn emoji

      this.valueMessage = this.valueMessage + emoji.i;
      this.$refs.inputBar.focus();
    },

    scrollDownToNewMessage() {
      this.$nextTick(() => {
        const messageContainer = this.$refs.messageContainer;
        messageContainer.scrollTop = messageContainer.scrollHeight;
      });
    },

    onClickEmojiPicker(event) {
      event.stopPropagation();
      this.isShowEmojis = true;
      // this.$emit("onChangeEmojiPicker", true);
    },

    /**
     * Format icon
     * @param {*} str
     */
    isIconString(str) {
      // Kiểm tra xem chuỗi có chứa các ký tự đặc biệt không (icon)
      const regex = new RegExp(
        /[\uD800-\uDFFF\u2600-\u26FF\u2700-\u27BF\u2B50]+/
      );

      // Check chữ và số và kí hiệu
      const hasLetterOrNumberRegex = /[a-zA-Z0-9]/;
      const hasIconRegex = regex.test(str.toString());
      const hasTextRegex = hasLetterOrNumberRegex.test(str.toString());

      if (hasIconRegex === true && hasTextRegex === false) {
        return true;
      } else {
        return false;
      }
    },

    formattedString(val) {
      // Thay thế \n bằng thẻ xuống dòng trong HTML
      return val.replace(/\n/g, "<br>");
    },

    // Click đóng form chat
    onClickHideMessage(val) {
      // eslint-disable-next-line prettier/prettier
      const messageSelected = this.$store.state.messageModule
        .listMessageSelected;
      const idUserSelected = messageSelected.find((x) => x.idChannel === val);

      if (idUserSelected) {
        this.setRemoveMessage(val);
      }
    },

    // Gửi icon
    async sendHandIcon(val) {
      const icon = val;

      if (this.idUser.length === 2) {
        await this.addMessageChanel({
          idMessage: this.idChannelMessage,
          objectMessage: {
            text: icon,
            image: "",
            icons: [],
            reacts: [],
          },
        });
        this.$refs.inputBar.focus();
        this.scrollDownToNewMessage();
        this.getListChanelId({
          pageSize: 50,
          currentPage: 0,
        });
      } else {
        this.errorSend();
      }
    },

    // Enter send message
    async handleEnterKey() {
      if (this.idUser.length === 2) {
        await this.addMessageChanel({
          idMessage: this.idChannelMessage,
          objectMessage: {
            text: this.valueMessage,
            image: "",
            icons: [],
            reacts: [],
          },
        });
        this.valueMessage = "";
        this.$refs.inputBar.focus();
        this.scrollDownToNewMessage();
        this.getListChanelId({
          pageSize: 50,
          currentPage: 0,
        });
      } else {
        this.valueMessage = "";
        this.errorSend();
      }
    },

    onClickShowDetailFriend(val) {
      debugger;
      const idUserLocal = localStorage.getItem("idUser");
      const findName = val.find((x) => x._id !== idUserLocal);
      this.setInformationUserAdmin(findName);
      this.$emit("onShowDetailFriend", findName);
    },
  },
};
</script>

<style lang="scss" scoped>
.form-message {
  width: 20rem;
  height: 27rem;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.6);
  -moz-box-shadow: 0 0 10px rgba(0, 0, 0, 0.6);
  -webkit-box-shadow: 0 0 10px rgba(0, 0, 0, 0.6);
  -o-box-shadow: 0 0 10px rgba(0, 0, 0, 0.6);
}

.size-image-small {
  width: 30px;
  height: 30px;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  border-radius: 50px;
  border: 2px solid #b3a4a4;
}

.size-image-big {
  width: 50px;
  height: 50px;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  border-radius: 50px;
  border: 2px solid #b3a4a4;
}

.img_active {
  position: absolute;
  right: 0;
  bottom: 0;
  border: 2px solid white;
  border-radius: 10px;
}

.h-body-mes {
  height: calc(100% - 3rem);
  background-color: #ffffff;
}

.form-container {
  border: 1px solid;
  overflow: auto;
  max-height: 7rem;
}

.form-div {
  width: 100%;
  padding-right: 25px;
  padding-bottom: 10px;
  padding-top: 10px;
  padding-left: 10px;
  min-height: 30px;
  overflow: auto;
}

.img-avatar {
  width: 30px;
  height: 30px;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  border-radius: 50px;
  border: 2px solid #b3a4a4;
  margin-right: 5px;
}

.form-mes {
  height: 21rem;
  min-height: 11rem;
  overflow-y: scroll;
}

.input-bar {
  border-radius: 4px;
  padding: 10px 30px 10px 10px;
  margin: 0 auto;
  background-color: #fff;
}

.input-bar p {
  margin: 0;
}

.input-bar span {
  display: block;
  color: #888;
  font-style: italic;
}

.input-bar[contenteditable="true"]:empty p span {
  display: block;
  color: #888;
  font-style: italic;
}

.input-bar:empty:before {
  content: "Aa";
  color: #888;
  font-style: italic;
}
.input-bar:focus {
  border: none; /* Đổi màu và kích thước của border tùy ý */
  outline: none; /* Loại bỏ viền mặc định */
}

input:focus {
  outline: none; /* Xóa border khi input được tập trung */
}

.head-mes {
  border-bottom: 1px solid #ebd2d2;
}

.h-footer-mes {
  height: calc(100% - 20rem);
}

$border-color: #ccc;
$background-color: #f4f6f9;
$input-padding: 4px;

// Styles for the textarea container
.textarea-container {
  width: 77%;
  max-width: 600px; // Adjust as needed
}

// Styles for the textarea itself
.textarea {
  padding: $input-padding;
  border: 1px solid $border-color;
  border-radius: 20px;
  background-color: $background-color;
  padding-right: 33px;
  padding-left: 10px;
  font-size: 14px; // Adjust as needed
  resize: none;
  height: 100%;
  width: 100%;
  max-height: 180px;
  position: absolute;
  left: 0;
  overflow: hidden;
}

.form-mes-w {
  border: 1px solid #ccc;
  border-radius: 20px;
  background-color: #f4f6f9;
  height: 35px;
  max-height: 195px;
}

.w-left-mes {
  width: calc(100% - 30px);
}

.form-icon {
  bottom: 4rem;
  left: -2rem;
}

.z-form {
  z-index: 9999;
}
.bor-first-right {
  border-bottom-left-radius: 18px;
  border-bottom-right-radius: 4px;
  border-top-left-radius: 18px;
  border-top-right-radius: 18px;
}

.bor-last-right {
  border-bottom-left-radius: 18px;
  border-bottom-right-radius: 18px;
  border-top-left-radius: 18px;
  border-top-right-radius: 4px;
}

.bor-middle-right {
  border-bottom-left-radius: 18px;
  border-bottom-right-radius: 4px;
  border-top-left-radius: 18px;
  border-top-right-radius: 4px;
}

.bor-first-left {
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 18px;
  border-top-left-radius: 18px;
  border-top-right-radius: 18px;
}

.bor-last-left {
  border-bottom-left-radius: 18px;
  border-bottom-right-radius: 18px;
  border-top-left-radius: 4px;
  border-top-right-radius: 18px;
}

.bor-middle-left {
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 18px;
  border-top-left-radius: 4px;
  border-top-right-radius: 18px;
}

.bor-middle-single {
  border-bottom-left-radius: 18px;
  border-bottom-right-radius: 18px;
  border-top-left-radius: 18px;
  border-top-right-radius: 18px;
}
.pad-mes {
  padding-bottom: 6px;
  padding-top: 6px;
  padding-left: 12px;
  padding-right: 12px;
  max-width: 200 px;
  word-break: break-word;
}
</style>
